import { OutlinedInput, type OutlinedInputProps } from "@mui/material";

export type TextAreaProps = Omit<
  OutlinedInputProps,
  "startAdornment" | "endAdornment" | "multiline" | "size"
>;

export function TextArea(props: TextAreaProps) {
  return <OutlinedInput {...props} multiline size="medium" />;
}
